import BaseObject from '../../../base/base_object';
import ServiceFactory from '../../service_factory';
import GenericRestrictionValue from '../values/generic_restriction_value';
import IRestrictionValueBase from '../values/restriction_value_base_interface';

export interface IRestrictionValueFactory {
  createRestrictionValue(actionId: number, restrictionData: any): IRestrictionValueBase;
}

class RestrictionValueFactory extends BaseObject implements IRestrictionValueFactory{
  static CLASS = 'RestrictionValueFactory';
  private _serviceFactory: ServiceFactory;

  init(params) {
    super.init(params);
    this._serviceFactory = params.serviceFactory;
  }

  public createRestrictionValue(actionId: number, restrictionData: any): IRestrictionValueBase {
    return GenericRestrictionValue.create({
      serviceFactory: this._serviceFactory,
      restrictionData: restrictionData,
      actionId: actionId,
    });
  }
}

export { RestrictionValueFactory };